// Invitation links shown once (Lane 1331). While email is off the server
// returns each new raw link one time only; it is never stored, so the buyer
// copies it now or reissues it later from the Invitations tab.
import React, { useRef, useState } from 'react';
import { portalJoinUrl } from './sourcingApi';

function LinkRow({ name, email, url }) {
  const inputRef = useRef(null);
  const [state, setState] = useState('');
  const copy = async () => {
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('no clipboard');
      await navigator.clipboard.writeText(url);
      setState('copied');
    } catch (e) {
      if (inputRef.current) { inputRef.current.focus(); inputRef.current.select(); }
      setState('select');
    }
  };
  return (
    <div className="srce-linkrow">
      <div className="srce-linkrow-who">
        <span className="srce-strong">{name || 'Supplier'}</span>
        <span className="srce-mut">{email}</span>
      </div>
      <input ref={inputRef} className="srce-input srce-linkrow-url" value={url} readOnly aria-label={`Join link for ${email}`}
        onFocus={(e) => e.target.select()} />
      <button type="button" className="srce-btn srce-btn--primary" onClick={copy}>Copy link</button>
      {state === 'copied' && <span className="srce-good">Copied</span>}
      {state === 'select' && <span className="srce-mut">Press Ctrl+C or Cmd+C to copy.</span>}
    </div>
  );
}

// `links`: [{invitation_id, supplier_id, email, token}]. `names`: supplier_id -> name.
export default function InvitationLinks({ links, names = {} }) {
  if (!links || links.length === 0) return null;
  return (
    <div className="srce-links">
      <div className="srce-warnbox">
        Email is off, so Wingman did not send these invitations. Copy each link and send it to the person yourself.
        These links are shown only now. If one is lost, reissue it from the Invitations tab.
      </div>
      {links.map((l) => (
        <LinkRow key={l.invitation_id} name={names[l.supplier_id]} email={l.email} url={portalJoinUrl(l.token)} />
      ))}
    </div>
  );
}

export const DELIVERY_TEXT = {
  email_off: 'Email off, link shown to you',
  pending: 'Sending email',
  sent: 'Email sent',
  failed: 'Email failed',
};
